/**
 * PDP v2 set price line element (019 M4, S2): <pdp-set-price>, "{price} in a
 * set of [min]+" under the price. Loaded by the set row after pdp-v2-set-api.js
 * (pantQuote, liveOffer); split from pdp-v2-set.js for the §11 budget (plan
 * 001 A6). Hidden once its slot is no longer live (002-F1).
 */
(function () {
  'use strict';

  var theme = window.theme = window.theme || {};
  var api = theme.pdpV2;
  if (!api || typeof api.pantQuote !== 'function' || api.__setPriceInitialised) return;
  api.__setPriceInitialised = true;

  var coApi = api.coApi;
  var fill = api.fill;

  class PdpSetPrice extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.config = api.readIsland(this, 'script[data-set-price]') || {};
      this.form = this.closest('product-form');
      this._onRender = this.render.bind(this);
      document.addEventListener('on:collection-offer:state', this._onRender);
      if (this.form) this.form.addEventListener('on:variant:change', this._onRender);
      this.render();
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      document.removeEventListener('on:collection-offer:state', this._onRender);
      if (this.form) this.form.removeEventListener('on:variant:change', this._onRender);
    }

    render() {
      var co = coApi();
      var text = this.querySelector('[data-set-price-text]');
      var injected = api.isInjected(this);
      var row = document.querySelector('.section-main-product pdp-set-row');
      if (!co || !text || (!row && !injected)) { this.hidden = true; return; }
      var offer = { slot: Number(this.config.slot), percentage: Number(this.config.percentage), min: Number(this.config.min) };
      // 002-F1: no live slot, no set price.
      if (!api.liveOffer(co, offer)) { this.hidden = true; return; }
      var picker = this.form && this.form.querySelector('variant-picker');
      var data = picker && typeof picker.getVariantData === 'function' ? picker.getVariantData() : null;
      var v = (picker && picker.variant) || ((data && data.variants) || []).find(function (x) { return x.available; });
      if (!v) { this.hidden = true; return; }
      var st = typeof co.getState === 'function' ? co.getState() : { loaded: false };
      var lines = st && st.loaded && st.cart && Array.isArray(st.cart.lines) ? st.cart.lines : [];
      var q = api.pantQuote(co, offer, lines, { price: v.price, compareAt: v.compare_at_price || 0 });
      if (q.saving <= 0) { this.hidden = true; return; }
      text.textContent = fill(this.config.template, {
        price: theme.formatMoney(q.setPrice, { currency: this.config.currency }),
        min: offer.min,
        percentage: offer.percentage
      });
      this.hidden = false;
    }
  }

  if (!customElements.get('pdp-set-price')) customElements.define('pdp-set-price', PdpSetPrice);
})();
